<template>
  <div class="flex flex-wrap items-center gap-2">
    <template v-if="special">
      <span
        v-if="vacancy.salary_per_hour >= 17.5"
        :class="specialLabelClasses"
      >&#128293; Top salaris</span>
      <span
        v-if="vacancy.commissioner?.published"
        :class="specialLabelClasses"
      >🏅 Top werkgever</span>
    </template>
    <template v-else>
      <span
        v-if="vacancy.salary && vacancy.salary_unit"
        class="tag tag-gray lg:text-base"
      >💰 {{ salary }} per {{ salaryUnit }}</span>
      <NuxtLink
        v-if="vacancy.city && vacancy?.location?.published"
        :to="{name: 'vacatures-in-slug', params: {'slug': citySlug}}"
        class="tag tag-gray lg:text-base lg:font-normal"
      >
        📍 {{ vacancy.city }}
      </NuxtLink>
      <span
        v-else-if="vacancy.city"
        class="tag tag-gray lg:text-base"
      >📍 {{ vacancy.city }}</span>
      <span
        v-if="vacancy.hours_per_week && !hideHours"
        class="tag tag-gray lg:text-base"
      >⏱ {{ vacancy.hours_per_week }} uur</span>
      <NuxtLink
        v-if="vacancy.sector"
        :to="`/${vacancy.sector.slug}`"
        class="tag tag-gray lg:text-base lg:font-normal"
      >
        👉 {{ vacancy.sector.title }}
      </NuxtLink>
    </template>
  </div>
</template>

<script setup lang="ts">
import type {Vacancy} from '~/graphql/graphql';

const props = defineProps<{
  hideHours?: boolean
  disabled?: boolean
  detailPage?: boolean
  special?: boolean
  vacancy?: Vacancy
}>();

const salaryUnit = computed(() => props.vacancy.salary_unit.replace(/hour/i, 'uur').replace(/month/i, 'maand'));

const slugify = (...args: (string | number)[]): string => {
  const value = args.join(' ');

  return value
    .normalize('NFD') // split an accented letter in the base letter and the accent
    .replace(/[\u0300-\u036F]/g, '') // remove all previously split accents
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9 ]/g, '') // remove all chars not letters, numbers and spaces (to be replaced)
    .replace(/\s+/g, '-'); // separator
};

const citySlug = computed(() => slugify(props.vacancy.city));

const salary = computed(() => {
  return '€' + (props.vacancy.salary + (props.vacancy.salary_max ? (' - €' + props.vacancy.salary_max) : '')).replace('.', ',');
});

const specialLabelClasses = computed(() => {
  return ['tag tag-violet lg:text-base'];
});
</script>
